module.exports = "/images/more-plus.svg?17bc7e81e7176e016cdcb041f81fabcd";